export default __webpack_public_path__ + "static/homepage-476e3e79180d43b666bb4435da5f74f7.jpg";